<p-toast></p-toast>
<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<p-dialog id="CreateNewDocument"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '80vw', height: '60hw'}">
  <!--
    // 1 - Create Proforma
    // 2 - Create Invoice
    // 3 - Create Receipt
    // 4 - Create Shipment
    // 5 - Create Transaction
    // 6 - Create Specification
    // 7 - Create PurchOrder
    // 9 - Create Payment
    // 10 - Inventory Checking result
    // 16 - Create Formular
  -->
  <ng-template pTemplate="content">
    <div class="grid">
      <p-tabView class="mt-2" [(activeIndex)]="tabIndex" (onChange)="onTabChange($event)">
        <p-tabPanel [cache]="false" [disabled]="false">
          <ng-template pTemplate="header">
            <i class="pi pi-plus mr-2"></i><h5>Новый документ <span *ngIf="debugMode">{{action}}</span></h5>
          </ng-template>
          <p-button label="Выставить КП" class="col mr-2" (onClick)="onCreateProforma($event)"
                    [severity]="(action===1)?'success':'primary'" pTooltip="Создать новое коммерческое предложение" tooltipPosition="top">
          </p-button>
          <p-button label="Выставить счет" class="col mr-2" (onClick)="onCreateInvoice($event)"
                    [severity]="(action===2)?'success':'primary'" pTooltip="Создать новый счет" tooltipPosition="top"></p-button>
          <p-button label="Принять товар" class="col mr-2" (onClick)="onCreateIncomeReceipt($event)"
                    [severity]="(action===3)?'success':'primary'" pTooltip="Создать новую приходную накладную" tooltipPosition="top"></p-button>
          <p-button label="Запланировать поставку" class="col mr-2" (onClick)="onCreatePurchaseOrder($event)"
                    [severity]="(action===7)?'success':'primary'" pTooltip="Создать новый заказ поставщика" tooltipPosition="top"></p-button>
          <p-button label="Результаты инвентаризации" class="col " (onClick)="onCreateInventorySheet($event)"
                    [severity]="(action===10)?'success':'primary'" pTooltip="Создать отчет об инвентаризации" tooltipPosition="top"></p-button>
          <p-button label="Перемещения" class="col mr-2" (onClick)="onCreateTransaction($event)"
                    [severity]="(action===5)?'success':'primary'" pTooltip="Провести перемещение товара между складами и подразделениями компании" tooltipPosition="top"></p-button>
        </p-tabPanel>

        <p-tabPanel [cache]="false" [disabled]="!hasParentDocument">
          <ng-template pTemplate="header">
            <i class="pi pi-sitemap mr-2"></i>
            <h5>Новый документ на основе <strong>{{parentDocumentNumber}}</strong></h5>
          </ng-template>
          <p-button label="Выставить КП" class="mr-2" (onClick)="onCreateChildProforma($event)" [disabled]="!canCreate(12)" *ngIf="canCreate(12)"
                    [severity]="(action==1)?'success':'primary'" pTooltip="Создать коммерческое предложение на основе существующего документа" tooltipPosition="top"></p-button>
          <p-button label="Выставить счет" class="mr-2" (onClick)="onCreateChildInvoice($event)" [disabled]="!canCreate(1)" *ngIf="canCreate(1)"
                    [severity]="(action==2)?'success':'primary'" pTooltip="Создать счет на основе существующего документа" tooltipPosition="top"></p-button>
          <p-button label="Отгрузить товар" class="col mr-2" (onClick)="onCreateChildShipment($event)" [disabled]="!canCreate(4)" *ngIf="canCreate(4)"
                    [severity]="(action==4)?'success':'primary'" pTooltip="Создать отгрузку на основе существующего документа" tooltipPosition="top"></p-button>
          <p-button label="Провести оплату" class="col mr-2" (onClick)="onCreateChildPayment($event)" [disabled]="!canCreate(9)" *ngIf="canCreate(9)"
                    [severity]="(action==9)?'success':'primary'" pTooltip="Провести оплату для существующего документа" tooltipPosition="top"></p-button>
          <p-button label="Запланировать поставку" class="col mr-2" (onClick)="onCreateChildPurchOrder($event)" [disabled]="!canCreate(10)" *ngIf="canCreate(10)"
                    [severity]="(action==7)?'success':'primary'" pTooltip="Создать новый заказ поставщика" tooltipPosition="top"></p-button>
          <p-button label="Принять товар" class="col mr-2" (onClick)="onCreateChildIncomeReceipt($event)" [disabled]="!canCreate(3)" *ngIf="canCreate(3)"
                    [severity]="(action==3)?'success':'primary'" pTooltip="Создать новую приходную накладную" tooltipPosition="top"></p-button>
          <p-button label="Производство и перемещения" class="col mr-2" (onClick)="onCreateChildTransaction($event)" [disabled]="!canCreate(5)" *ngIf="canCreate(5)"
                    [severity]="(action==5)?'success':'primary'" pTooltip="Провести перемещение товара на основе существующего документа" tooltipPosition="top"></p-button>
          <p-button label="Выписать гарантийный талон" class="col " (onClick)="onCreateChildSpecification($event)" [disabled]="!canCreate(7)" *ngIf="canCreate(7)"
                    [severity]="(action==6)?'success':'primary'" pTooltip="Выписать гарантийный талон для существующего документа" tooltipPosition="top"></p-button>
          <p-button label="Создать паспорт" class="col " (onClick)="onCreateChildFormular($event)" [disabled]="!canCreate(16)" *ngIf="canCreate(16)"
                    [severity]="(action==16)?'success':'primary'" pTooltip="Выписать паспорт компьютера собственного производства" tooltipPosition="top"></p-button>

        </p-tabPanel>

        <p-tabPanel [cache]="false" [disabled]="!agentRequestId" *ngIf="agentRequestId">
          <ng-template pTemplate="header">
            <i class="pi pi-envelope mr-2"></i><h5>AI Assist</h5>
          </ng-template>
          <!-- This tab renders the standard blocks itself (see the component's own class
               comment) so the AI's findings can sit *between* them; the accordion below is
               suppressed while this tab is active to avoid showing them twice. -->
          <app-new-document-dlg-ai-assist
            [requestId]="agentRequestId"
            [newDocument]="newDocument"
            [parentDocument]="parentDocument"
            [docHeader]="activeConfig?.header"
            [resultPartnerName]="resultPartnerName"
            [checkSelectedClientData]="checkSelectedClientData"
            [needClentSearch]="needClentSearch"
            (applyToDocument)="onApplyAgentRequest($event)"
            (itemsChange)="onAgentItemsChange($event)"
            (selectedIds)="onSelectedIds($event)"
            (newDocumentUpdate)="onNewDocumentUpdate($event)"
            (abandoned)="onAgentRequestAbandoned()">
          </app-new-document-dlg-ai-assist>
        </p-tabPanel>

      </p-tabView>
    </div>

    <!-- Document Creation Form — config-driven single fieldset.
         Hidden while the "AI Assist" tab is active: that tab renders these same blocks
         inside its own accordion so the agent's findings can be interleaved with them. -->
    <div class="grid" *ngIf="!isAgentTabActive && newDocument && activeConfig as cfg">

      <p-fieldset class="col-12">
        <ng-template pTemplate="header">
          <h3>{{ cfg.header }}</h3>
        </ng-template>

        <p-accordion [multiple]="true">

          <!-- ── Dates tab — variant per document type ── -->

          <!-- standard: Proforma, Invoice -->
          <p-accordionTab [selected]="true" *ngIf="cfg.datesVariant === 'standard'">
            <ng-template pTemplate="header"><h5>Дата, валюта, продавец</h5></ng-template>
            <app-new-document-dlg-dates appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-dates>
          </p-accordionTab>

          <!-- receipt: Income Receipt -->
          <p-accordionTab [selected]="true" *ngIf="cfg.datesVariant === 'receipt'">
            <ng-template pTemplate="header"><h5>Дата, валюта, получатель товара</h5></ng-template>
            <app-new-document-dlg-dates appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [selectDepartmentOn]="true"
              manDepLabel="Склад - получатель продукции"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-dates>
          </p-accordionTab>

          <!-- shipment-spec: Shipment, Specification, Formular -->
          <p-accordionTab [selected]="true" *ngIf="cfg.datesVariant === 'shipment-spec'">
            <ng-template pTemplate="header"><h5>Дата, валюта, отправитель товара</h5></ng-template>
            <app-new-document-dlg-dates appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              lcoLabel="Юридическое лицо продавца"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-dates>
          </p-accordionTab>

          <!-- transaction: Movement -->
          <p-accordionTab [selected]="openDateAndCurrencyTab" *ngIf="cfg.datesVariant === 'transaction'">
            <ng-template pTemplate="header"><h5>Дата, валюта, отправитель товара</h5></ng-template>
            <app-new-document-dlg-dates appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              lcoLabel="Юридическое лицо"
              pcoPerLabel="Представитель отправителя"
              [selectDepartmentOn]="true"
              manDepLabel="Отдел - поставщик продукции"
              (newDocumentUpdate)="onNewTransactionUpdate($event)">
            </app-new-document-dlg-dates>
          </p-accordionTab>

          <!-- po: Purchase Order -->
          <p-accordionTab [selected]="true" *ngIf="cfg.datesVariant === 'po'">
            <ng-template pTemplate="header"><h5>Дата, валюта, получатель товара</h5></ng-template>
            <app-new-document-dlg-dates appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              lcoLabel="Юридическое лицо покупателя (импортера)"
              pcoPerLabel="Представитель покупателя (импортера)"
              [selectDepartmentOn]="true"
              manDepLabel="Отдел - получатель продукции"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-dates>
          </p-accordionTab>

          <!-- payment: Payment -->
          <p-accordionTab [selected]="true" *ngIf="cfg.datesVariant === 'payment'">
            <ng-template pTemplate="header"><h5>Дата, валюта, продавец</h5></ng-template>
            <app-new-document-dlg-dates appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              data1Label="Дата оплаты" data2Label="Дата оплаты 2" data3Label="Дата оплаты 3">
            </app-new-document-dlg-dates>
          </p-accordionTab>

          <!-- inventory: Inventory -->
          <p-accordionTab [selected]="true" *ngIf="cfg.datesVariant === 'inventory'">
            <ng-template pTemplate="header"><h5>Дата, валюта, юридическое лицо и отдел - объекты инвентаризации</h5></ng-template>
            <app-new-document-dlg-dates appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              lcoLabel="Юридическое лицо - объект инвентаризации:"
              [selectDepartmentOn]="true"
              manDepLabel="Отдел - объект инвентаризации:"
              (newDocumentUpdate)="onNewInventoryUpdate($event)">
            </app-new-document-dlg-dates>
          </p-accordionTab>

          <!-- ── Company search — conditional ── -->
          <p-accordionTab [selected]="needClentSearch" *ngIf="cfg.showSearch">
            <ng-template pTemplate="header"><h5>Поиск контрагента</h5></ng-template>
            <app-company-search appStopAccordionHomeEnd
              header="Поиск организации-контрагента"
              (selectedIds)="onSelectedIds($event)">
            </app-company-search>
          </p-accordionTab>

          <!-- ── Companies result — variant: standard / receipt / inventory ── -->
          <p-accordionTab [selected]="checkSelectedClientData" *ngIf="cfg.companiesVariant === 'standard' && cfg.processVariant !== 'po'">
            <ng-template pTemplate="header"><h5>Результат поиска контрагента {{resultPartnerName}}</h5></ng-template>
            <app-new-document-dlg-companies appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-companies>
          </p-accordionTab>

          <!-- PO companies has additional labels -->
          <p-accordionTab [selected]="checkSelectedClientData" *ngIf="cfg.processVariant === 'po'">
            <ng-template pTemplate="header"><h5>Результат поиска контрагента {{resultPartnerName}}</h5></ng-template>
            <app-new-document-dlg-companies appStopAccordionHomeEnd
              [newDocument]="newDocument"
              cliComLabel="Поставщик"
              cliPerLabel="Контактное лицо поставщика"
              pcoComLabel="Юридическое лицо поставщика"
              pcoPerLabel="Отвественный у поставщика"
              [parentDocument]="parentDocument"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-companies>
          </p-accordionTab>

          <!-- transaction recipient tab -->
          <p-accordionTab [selected]="openRecipientTab" *ngIf="cfg.companiesVariant === 'receipt'">
            <ng-template pTemplate="header"><h5>Данные отдела - получателя продукции</h5></ng-template>
            <app-new-document-dlg-companies-receipt appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-companies-receipt>
          </p-accordionTab>

          <!-- inventory companies control -->
          <p-accordionTab [selected]="false" *ngIf="cfg.companiesVariant === 'inventory'">
            <ng-template pTemplate="header"><h5>Контроль данных компании</h5></ng-template>
            <app-new-document-dlg-companies-inventory appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-companies-inventory>
          </p-accordionTab>

          <!-- inventory: client inventory selector -->
          <p-accordionTab [selected]="true" *ngIf="cfg.processVariant === 'inventory'">
            <ng-template pTemplate="header"><h5>Юридическое лицо и отдел - объекты инвентаризации</h5></ng-template>
            <app-new-document-dlg-client-inventory appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              (newDocumentUpdate)="onNewDocumentUpdate($event)">
            </app-new-document-dlg-client-inventory>
          </p-accordionTab>

          <!-- ── Conditions tab — variant ── -->
          <p-accordionTab [selected]="cfg.conditionsSelected" *ngIf="cfg.conditionsVariant === 'standard'">
            <ng-template pTemplate="header"><h5>{{ cfg.conditionsLabel ?? 'Условия поставки' }}</h5></ng-template>
            <app-edit-document-conditions appStopAccordionHomeEnd [document]="newDocument"></app-edit-document-conditions>
          </p-accordionTab>

          <p-accordionTab [selected]="cfg.conditionsSelected" *ngIf="cfg.conditionsVariant === 'receipt'">
            <ng-template pTemplate="header"><h5>{{ cfg.conditionsLabel ?? 'Условия поставки' }}</h5></ng-template>
            <app-edit-document-conditions-receipt appStopAccordionHomeEnd [document]="newDocument"></app-edit-document-conditions-receipt>
          </p-accordionTab>

          <p-accordionTab [selected]="cfg.conditionsSelected" *ngIf="cfg.conditionsVariant === 'po'">
            <ng-template pTemplate="header"><h5>{{ cfg.conditionsLabel ?? 'Условия поставки' }}</h5></ng-template>
            <app-edit-document-conditions appStopAccordionHomeEnd
              [document]="newDocument"
              [options1]="poOptions1"
              [options2]="poOptions2"
              [options3]="poOptions3"
              [selected1]="poSelected1"
              [selected2]="poSelected2"
              [selected3]="poSelected3"
              docNoteText1="Примечание для получателя груза (наши заметки)"
              docNoteText2="Примечания для поставщика (видны в документе)">
            </app-edit-document-conditions>
          </p-accordionTab>

          <!-- 'notes' variant: uses conditions-receipt component for free-form notes (transaction, spec, inventory) -->
          <p-accordionTab [selected]="cfg.conditionsSelected" *ngIf="cfg.conditionsVariant === 'notes'">
            <ng-template pTemplate="header"><h5>{{ cfg.conditionsLabel }}</h5></ng-template>
            <app-new-document-dlg-conditions-receipt appStopAccordionHomeEnd [newDocument]="newDocument"></app-new-document-dlg-conditions-receipt>
          </p-accordionTab>

          <!-- 'formular-notes' variant: conditions-receipt with model/serial labels (formular) -->
          <p-accordionTab [selected]="cfg.conditionsSelected" *ngIf="cfg.conditionsVariant === 'formular-notes'">
            <ng-template pTemplate="header"><h5>{{ cfg.conditionsLabel }}</h5></ng-template>
            <app-new-document-dlg-conditions-receipt appStopAccordionHomeEnd
              [newDocument]="newDocument"
              sNoteLable="Модель"
              bNoteLable="Серийный номер">
            </app-new-document-dlg-conditions-receipt>
          </p-accordionTab>

          <!-- ── Products — new documents only ──
               Every process tab below is guarded by `parentDocument`, because their rows
               are *derived* from a parent document. A document started from scratch had
               nowhere to put products at all: they were added afterwards, on the edit
               page. This tab is that missing half, and it is the same table component the
               derived tabs use, switched into capture mode with `allowAdd`. -->
          <p-accordionTab [selected]="docContentIsReady" *ngIf="!parentDocument && cfg.showDocItems && cfg.processVariant === 'invoice'">
            <ng-template pTemplate="header"><h5>Товары ({{ newDocument.items?.length ?? 0 }})</h5></ng-template>
            <app-new-document-dlg-doc-items appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [allowAdd]="true"
              [showStock]="false"
              [showReserve]="false"
              [showSold]="false"
              [showShipped]="false"
              [showDiscount]="false"
              [showU4etka]="false"
              [showNote]="false"
              [showVprice]="false"
              [showDepartments]="false">
            </app-new-document-dlg-doc-items>
          </p-accordionTab>

          <!-- ── Process tab — variant-specific ── -->

          <!-- invoice process (Proforma, Invoice) — guarded by parentDocument -->
          <p-accordionTab [selected]="true" *ngIf="parentDocument && cfg.processVariant === 'invoice'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-invoice appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [docDate]="newDocument.DOCDATE"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-invoice>
          </p-accordionTab>

          <!-- receipt process (Income Receipt) — guarded by parentDocument -->
          <p-accordionTab [selected]="true" *ngIf="parentDocument && cfg.processVariant === 'receipt'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-receipt appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-receipt>
          </p-accordionTab>

          <!-- shipment process — guarded by parentDocument -->
          <p-accordionTab [selected]="true" *ngIf="parentDocument && cfg.processVariant === 'shipment'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-shipment appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-shipment>
          </p-accordionTab>

          <!-- po process — guarded by parentDocument -->
          <p-accordionTab [selected]="true" *ngIf="parentDocument && cfg.processVariant === 'po'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-po appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-po>
          </p-accordionTab>

          <!-- payment process — NOT guarded by parentDocument (matches original template) -->
          <p-accordionTab [selected]="true" *ngIf="cfg.processVariant === 'payment'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-payment appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument">
            </app-new-document-dlg-process-payment>
          </p-accordionTab>

          <!-- spec process (Specification) — guarded by parentDocument -->
          <p-accordionTab [selected]="true" *ngIf="parentDocument && cfg.processVariant === 'spec'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-spec appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              [newDocuments]="newDocuments"
              (onCreateNewDocuments)="onCreateNewDocuments($event)"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-spec>
          </p-accordionTab>

          <!-- formular process — same component as spec, guarded by parentDocument -->
          <p-accordionTab [selected]="true" *ngIf="parentDocument && cfg.processVariant === 'formular'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-spec appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              [newDocuments]="newDocuments"
              (onCreateNewDocuments)="onCreateNewDocuments($event)"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-spec>
          </p-accordionTab>

          <!-- transaction process — guarded by parentDocument -->
          <p-accordionTab [selected]="!manProcessEnded" *ngIf="parentDocument && cfg.processVariant === 'transaction'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-transaction appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              [newDocuments]="newDocuments"
              (onCreateNewDocuments)="onCreateNewDocuments($event)"
              (onGetTransactionResult)="getTransactionResult($event)"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-transaction>
          </p-accordionTab>

          <!-- inventory process (uses receipt component) — guarded by parentDocument -->
          <p-accordionTab [selected]="true" *ngIf="parentDocument && cfg.processVariant === 'inventory'">
            <ng-template pTemplate="header"><h5>Параметры документа и содержимое</h5></ng-template>
            <app-new-document-dlg-process-receipt appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [parentDocument]="parentDocument"
              [docItems]="parentDocItems"
              (onCreateNewDocuments)="onCreateNewDocuments($event)"
              (blocking)="blocked=$event"
              [countEmptyDocItems]="countEmptyDocItems">
            </app-new-document-dlg-process-receipt>
          </p-accordionTab>

          <!-- ── Transaction result documents ── -->
          <p-accordionTab [selected]="docContentIsReady"
                          *ngIf="cfg.processVariant === 'transaction' && parentDocument && newDocuments && (newDocuments.length > 0)">
            <ng-template pTemplate="header">
              <h5>Результат Формирования документов - Будет создано {{newDocuments.length}} новых</h5>
            </ng-template>

            <p-accordion [multiple]="true">
              <p-accordionTab [selected]="true" *ngIf="transactionResult">
                <ng-template pTemplate="header"><h5>Ожидаемый Результат Производства</h5></ng-template>
                <div *ngIf="transactionResult as targetPartsCache">
                  <p-table #tpctable1 [value]="targetPartsCache"
                           [rows]="10"
                           [rowsPerPageOptions]="[10,25,50]"
                           [paginator]="(targetPartsCache.length > 10)"
                           currentPageReportTemplate="Показано от {first} до {last} из {targetPartsCache.length} строк"
                           [totalRecords]="targetPartsCache.length"
                           [resizableColumns]="true"
                           [rowHover]="true"
                           dataKey="partid"
                           selectionMode="single"
                           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
                    <ng-template pTemplate="header">
                      <tr>
                        <th pResizableColumn pSortableColumn="PRODCODE" style="width: 35%">Изделие <p-sortIcon field="PRODCODE"></p-sortIcon></th>
                        <th pResizableColumn pSortableColumn="PARTCODE" style="width: 25%">Часть <p-sortIcon field="PARTCODE"></p-sortIcon></th>
                        <th pResizableColumn pSortableColumn="perUnitQty" style="width: 8rem">На единицу <p-sortIcon field="perUnitQty"></p-sortIcon></th>
                        <th pResizableColumn pSortableColumn="requiredQty" style="width: 8rem">Требуется <p-sortIcon field="requiredQty"></p-sortIcon></th>
                        <th pResizableColumn pSortableColumn="previuosQty" style="width: 8rem">Было <p-sortIcon field="previuosQty"></p-sortIcon></th>
                        <th pResizableColumn pSortableColumn="movedQty" style="width: 8rem">Передано <p-sortIcon field="movedQty"></p-sortIcon></th>
                        <th pResizableColumn pSortableColumn="movedPrice" style="width: 8rem">Цена <p-sortIcon field="movedPrice"></p-sortIcon></th>
                        <th pResizableColumn pSortableColumn="movedSum" style="width: 10rem">На сумму <p-sortIcon field="movedSum"></p-sortIcon></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-tpc>
                      <tr [pSelectableRow]="tpc" [class.yellow]="(tpc.previuosQty+tpc.movedQty)<tpc.requiredQty">
                        <td>{{tpc.PRODCODE}}</td>
                        <td>{{tpc.PARTCODE}}</td>
                        <td style="text-align: right">{{tpc.perUnitQty | number:'1.0-2' }}</td>
                        <td style="text-align: right">{{tpc.requiredQty | number:'1.0-2' }}</td>
                        <td style="text-align: right">{{tpc.previuosQty | number:'1.0-2' }}</td>
                        <td style="text-align: right">{{tpc.movedQty | number:'1.0-2' }}</td>
                        <td style="text-align: right">{{tpc.movedPrice | number:'1.2-2' }}</td>
                        <td style="text-align: right">{{tpc.movedSum | number:'1.2-2' }}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr><td colspan="8">Нет информации</td></tr>
                    </ng-template>
                  </p-table>
                </div>
              </p-accordionTab>

              <p-accordionTab [selected]="false" *ngFor="let doc of newDocuments">
                <ng-template pTemplate="header">
                  <h5>
                    <app-show-department-name [parentCompany]="doc.DOCMANCLIID" [selectedID]="doc.DOCMANDEPID"></app-show-department-name> ->
                    <app-show-department-name [parentCompany]="doc.DOCMANCLIID" [selectedID]="doc.DOCCLIDEPID"></app-show-department-name>
                  </h5>
                </ng-template>
                <app-new-document-dlg-doc-items appStopAccordionHomeEnd
                  [newDocument]="doc"
                  [showDiscount]="false"
                  [showReserve]="false"
                  [showSold]="false"
                  [showNote]="false"
                  [showU4etka]="false"
                  [showShipped]="false"
                  [showDepartments]="false"
                  U4ETKALabel="Входная">
                </app-new-document-dlg-doc-items>
              </p-accordionTab>
            </p-accordion>
          </p-accordionTab>

          <!-- ── Spec / Formular result doc-items (per newDocuments) ── -->
          <p-accordionTab [selected]="docContentIsReady"
                          *ngIf="parentDocument && (cfg.processVariant === 'spec' || cfg.processVariant === 'formular') && newDocuments && (newDocuments.length > 0)">
            <ng-template pTemplate="header">
              <h5>Результат Формирования документа - табличная часть ({{newDocument.items?.length ?? 0}})</h5>
            </ng-template>
            <app-new-document-dlg-doc-items appStopAccordionHomeEnd
              [newDocument]="doc"
              [showDiscount]="false"
              [showStock]="false"
              [showReserve]="false"
              [showSold]="false"
              [showNote]="true"
              [showPrice]="false"
              [showVprice]="false"
              [showNote2]="true"
              [showU4etka]="false"
              [showShipped]="false"
              [docNote1Header]="cfg.processVariant === 'formular' ? 'Серийный №' : 'Серийный №'"
              [docNote2Header]="cfg.processVariant === 'formular' ? 'Доп информация' : 'Гарантия'"
              *ngFor="let doc of newDocuments">
            </app-new-document-dlg-doc-items>
          </p-accordionTab>

          <!-- ── Payment doc-items (uses newDocument.items directly, no parentDocument guard) ── -->
          <p-accordionTab [selected]="docContentIsReady" *ngIf="cfg.processVariant === 'payment'">
            <ng-template pTemplate="header"><h5>Результат Формирования документа - табличная часть</h5></ng-template>
            <app-new-document-dlg-doc-items appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [docItems]="newDocument.items"
              [showStock]="false"
              [showNote]="false"
              [showDiscount]="false">
            </app-new-document-dlg-doc-items>
          </p-accordionTab>

          <!-- ── Standard doc-items — for invoice/receipt/shipment/po/inventory, guarded by parentDocument ── -->
          <p-accordionTab [selected]="docContentIsReady"
                          *ngIf="cfg.showDocItems && parentDocument
                                 && cfg.processVariant !== 'payment'
                                 && cfg.processVariant !== 'spec'
                                 && cfg.processVariant !== 'formular'
                                 && cfg.processVariant !== 'transaction'">
            <ng-template pTemplate="header"><h5>Результат Формирования документа - табличная часть</h5></ng-template>
            <app-new-document-dlg-doc-items appStopAccordionHomeEnd
              [newDocument]="newDocument"
              [showDiscount]="cfg.showDiscount"
              [showReserve]="cfg.showReserve"
              [showShipped]="cfg.showShipped"
              [showNote]="cfg.showNote"
              [showU4etka]="cfg.showU4etka"
              [U4ETKALabel]="cfg.processVariant === 'po' ? 'Инвойс' : cfg.processVariant === 'inventory' ? 'Входная' : null">
            </app-new-document-dlg-doc-items>
          </p-accordionTab>

        </p-accordion>
      </p-fieldset>

    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-checkbox *ngIf="!isNewDoc" disabled="true" label="Новый документ" class="col-2 mt-2"></p-checkbox>
    <p-checkbox *ngIf="!isLcoDep" disabled="true" label="Отдел" class="col-2 mt-2"></p-checkbox>
    <p-checkbox *ngIf="!isLcoPer" disabled="true" label="Ответственный" class="col-2 mt-2"></p-checkbox>

    <p-checkbox [(ngModel)]="navigateTo" [binary]="true" label="Открыть новый документ" class="col-2 mt-2" [disabled]="!singleDocumentOutput"></p-checkbox>

    <p-button label="Выполнить" icon="pi pi-check" (onClick)="onCreateDocument($event)" [disabled]="!ready2Create"
              pTooltip="Создать документ в системе" tooltipPosition="top"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
